/*
 * 佳安卫康内部流程
 */
import * as Names from '../statuses'
export default {
  name: 'LAB',
  statuses: [
    {
      name: Names.LAB_SAMPLE_RETURNED,
      description: '样本重采',
      operation: '样本重采',
      icon: ''
    },
    {
      name: Names.CREATED,
      description: '已创建',
      operation: '创建订单',
      icon: 'icon-dingdanchuangjian'
    },
    {
      name: Names.LAB_SAMPLES_RECEIVED,
      description: '实验室收到样本',
      operation: '样本接收',
      icon: 'icon-yangbenjieshou'
    },
    {
      name: Names.LAB_DNA_READY,
      description: '样本DNA提取',
      operation: '核酸提取',
      icon: 'icon-hesuantiqu'
    },
    {
      name: Names.DATA_ANALYSISED,
      description: '样本已检测',
      operation: '上机检测',
      icon: 'icon-shangjijiance'
    },
    {
      name: Names.REPORT_CREATED,
      description: '报告已生成',
      operation: '报告生成',
      icon: 'icon-baogaoshengcheng'
    },
    {
      name: Names.REPORT_CHECKED_1ST,
      description: '报告审核',
      operation: '报告审核',
      icon: 'icon-baogaoshenhe'
    },
    {
      name: Names.COMPLETED,
      description: '已完成',
      operation: '已完成',
      icon: 'icon-yiwancheng'
    },
    {
      name: Names.CLOSED,
      description: '已关闭',
      operation: '已关闭',
      icon: 'icon-dingdanguanbi'
    }
  ] }
